import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { useProcurementRuntime } from "../runtime/procurement-runtime";
import {
  destinationByPath,
  ProcurementDestinationRoute,
} from "../screens/procurement-shell";
import { Receiving } from "../screens/receiving";

export const Route = createFileRoute("/receiving")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { location?: string; group?: string } => ({
    ...(typeof search.location === "string" && search.location
      ? { location: search.location }
      : {}),
    ...(typeof search.group === "string" ? { group: search.group } : {}),
  }),
  component: ReceivingRoute,
});

function ReceivingRoute() {
  const { location, group } = Route.useSearch();
  const navigate = Route.useNavigate();
  const [editorName, setEditorName] = useState("");
  const { catalog, receiving } = useProcurementRuntime();
  const backToList = () =>
    void navigate({
      search: location ? { location } : {},
      replace: true,
      ignoreBlocker: true,
    });
  return (
    <ProcurementDestinationRoute
      destination={destinationByPath["/receiving"]}
      {...(group
        ? {
            recordBreadcrumb: {
              label: editorName || "SO / PO",
              onBack: backToList,
            },
          }
        : {})}
    >
      <Receiving
        catalog={catalog}
        receiving={receiving}
        locationID={location}
        requestedGroupID={group}
        onLocationChange={(ID) =>
          void navigate({ search: { location: ID }, replace: true })
        }
        onOpenGroup={(ID) =>
          void navigate({
            search: { ...(location ? { location } : {}), group: ID },
          })
        }
        onEditorNameChange={setEditorName}
        onRecorded={backToList}
      />
    </ProcurementDestinationRoute>
  );
}
